(() => {
  if (customElements.get('lt-showroom-map')) return;
  const loadMaps = (key) => {
    if (window.google?.maps?.Map) return Promise.resolve(window.google.maps);
    if (window.ltShowroomMapsPromise) return window.ltShowroomMapsPromise;
    window.ltShowroomMapsPromise = new Promise((resolve, reject) => {
      if (!key) return reject(new Error('Map configuration missing'));
      window.ltShowroomMapsReady = () => resolve(window.google.maps);
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&loading=async&callback=ltShowroomMapsReady`;
      script.async = true;
      script.onerror = reject;
      document.head.append(script);
      setTimeout(() => { if (!window.google?.maps?.Map) reject(new Error('Map unavailable')); }, 15000);
    });
    return window.ltShowroomMapsPromise;
  };
  customElements.define('lt-showroom-map', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.started = true;
          this.renderMap();
        }
      }, {rootMargin: '250px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async renderMap() {
      try {
        const maps = await loadMaps(this.dataset.key);
        const result = await new maps.Geocoder().geocode({address: this.dataset.address});
        if (!this.isConnected || !result.results[0]) return;
        const center = result.results[0].geometry.location;
        const map = new maps.Map(this.querySelector('.lt-showroom-map__canvas'), {
          center, zoom: 15, gestureHandling: 'cooperative', mapTypeControl: false,
          streetViewControl: false, fullscreenControl: true,
          styles: [
            {featureType:'all',stylers:[{saturation:-100}]},
            {featureType:'landscape',elementType:'geometry',stylers:[{color:'#e9e8e4'}]},
            {featureType:'road',elementType:'geometry',stylers:[{color:'#ffffff'}]},
            {featureType:'water',elementType:'geometry',stylers:[{color:'#cecfcb'}]},
            {featureType:'poi',elementType:'labels',stylers:[{visibility:'off'}]}
          ]
        });
        new maps.Marker({map, position:center, title:'LuminiTerasa — Intrarea Monahului 4', icon:{
          path:'M0 0C-3-5-11-14-11-22A11 11 0 0 1 11-22C11-14 3-5 0 0Z',
          fillColor:'#b49b48',fillOpacity:1,strokeColor:'#ffffff',strokeWeight:2,scale:1.5
        }});
        this.dataset.loaded = 'true';
      } catch {
        this.querySelector('[role="status"]').textContent = 'Harta nu este disponibilă momentan. Deschide „Cum ajungi la noi” pentru traseu.';
      }
    }
  });
})();
